// extracted by mini-css-extract-plugin
export var chip = "_3l-0";
export var filterDropdown = "_3l-5";
export var filterItem = "_3l-6";
export var icon = "_3l-1";
export var removeButton = "_3l-3";
export var removeIcon = "_3l-4";
export var separator = "_3l-2";